/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Content from "../../../../Components/Dashboard/Content/Content";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form1";
import * as valid_err from "../../../../Utils/Common_Messages";
import { Mobile_regex } from "../../../../Utils/Common_regex";

import { useFormik } from "formik";

import { useDispatch } from "react-redux";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import { GET_ALL_GROUP_SERVICES } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import {
  Find_One_Subadmin,
  Edit_Subadmin,
} from "../../../../ReduxStore/Slice/Admin/CreateSubadminSlice";

import toast from "react-hot-toast";

import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import Swal from "sweetalert2";

const AllSubadmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const user_token = JSON.parse(localStorage.getItem("user_details")).token;
  const Role = JSON.parse(localStorage.getItem("user_details")).Role;
  const user_id = JSON.parse(localStorage.getItem("user_details")).user_id;
  const token = JSON.parse(localStorage.getItem("user_details")).token;

  const [checkedStrategies, setCheckedStrategies] = useState([]);
  const [checkedGroupServices, setCheckedGroupServices] = useState([]);

  const [selectedStrategyIds, setSelectedStrategyIds] = useState([]);
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);

  const [AllGroupServices, setAllGroupServices] = useState({
    loading: true,
    data: [],
  });

  const [AllStrategy, setAllStrategy] = useState({
    loading: true,
    data: [],
  });

  const [UserData, setUserData] = useState({
    loading: true,
    data: [],
  });

  // Track if we're programmatically setting values to avoid infinite loops
  const [isUpdatingAll, setIsUpdatingAll] = React.useState(false);

  const isValidContact = (mobile) => {
    return Mobile_regex(mobile);
  };

  // GET USER DETAILS
  const data_1 = async () => {
    await dispatch(Find_One_Subadmin({ id: id, token: token }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setUserData({
            loading: false,
            data: response,
          });
        }
      });
  };
  useEffect(() => {
    data_1();
  }, []);

  const formik = useFormik({
    initialValues: {
      FullName: null,
      email: null,
      mobile: "null",
      password: "null",
      Strategy: false,
      select_strategy: [],
      gotodashboard: false,
      licence: false,
      detailsinfo: false,
      all: false,
      editclient: false,
      addclient: false,
      tradehistory: false,
      groupservice: false,
      updateapikeys: false,
      select_group_services: [],
      grouper_servcice: "",
      strateg_servcice: "",
      makestrategy: false,
      optionchain: false,
      apicreateinfo: false,
      Strategy_Permission: false,
      groupservice_Permission: false,
      create_strategy: false,
      stock_group_service: false,
    },
    touched: {
      FullName: false,
      email: false,
      mobile: false,
      password: false,
    },
    validate: (values) => {
      const errors = {};

      if (!values.password) {
        errors.password = valid_err.PASSWORD_ERROR;
      }
      if (!values.mobile && formik.touched.mobile) {
        errors.mobile = valid_err.CONTACT_ERROR;
      } else if (!isValidContact(values.mobile) && formik.touched.mobile) {
        errors.mobile = valid_err.INVALID_CONTACT_ERROR;
      }

      if (values?.Strategy) {
        if (!values?.addclient && !values?.editclient) {
          errors.addclient = "select Add Client Also";
          errors.editclient = "select Edit Client Also";
        }
      }
      if (values?.groupservice) {
        if (!values.addclient && !values.editclient) {
          errors.addclient = "select Add Client Also";
          errors.editclient = "select Edit Client Also";
        }
      }

      if (
        (values.addclient || values.editclient) &&
        values.groupservice &&
        selectedGroupIds.length === 0
      ) {
        errors.grouper_servcice =
          "You must select a Group Service from the list";
      }
      if (
        (values.addclient || values.editclient) &&
        values.Strategy &&
        selectedStrategyIds.length === 0
      ) {
        errors.strateg_servcice = "You must select a Strategy from the list";
      }

      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        FullName: values.FullName,
        Email: values.email,
        PhoneNo: values.mobile,
        password: values.password,
        Role: "SUBADMIN",
        parent_role: Role,
        parent_id: user_id,
        id: id,
        Subadmin_permision_data: {
          client_add: values?.addclient ? "1" : values.all ? "1" : "0",
          client_edit: values?.editclient ? "1" : values.all ? "1" : "0",
          license_permision: values?.licence ? "1" : values.all ? "1" : "0",
          go_To_Dashboard: values?.gotodashboard ? "1" : values.all ? "1" : "0",
          trade_history_old: values?.tradehistory
            ? "1"
            : values.all
              ? "1"
              : "0",
          detailsinfo: values?.detailsinfo ? "1" : values.all ? "1" : "0",
          strategy: values?.updateapikeys === true ? [] : selectedStrategyIds,
          Update_Api_Key: values?.updateapikeys ? "1" : "0",
          group_services:
            values?.updateapikeys === true ? [] : selectedGroupIds,
          makestrategy: values.makestrategy ? "1" : values.all ? "1" : "0",
          optionchain: values.optionchain ? "1" : values.all ? "1" : "0",
          apicreateinfo: values.apicreateinfo ? "1" : values.all ? "1" : "0",
          Strategy_Permission: values.Strategy_Permission
            ? "1"
            : values.all
              ? "1"
              : "0",
          fullAcess_Permission: values.fullAcess_Permission
            ? "1"
            : values.all
              ? "1"
              : "0",
          groupservice_Permission: values.groupservice_Permission
            ? "1"
            : values.all
              ? "1"
              : "0",
          create_strategy: values.create_strategy
            ? "1"
            : values.all
              ? "1"
              : "0",
          stock_group_service: values.stock_group_service
            ? "1"
            : values.all
              ? "1"
              : "0",
        },
      };

      await dispatch(Edit_Subadmin({ req: req, token: user_token }))
        .unwrap()
        .then((response) => {
          if (response.status) {
            toast.success(response.msg);
            setTimeout(() => {
              navigate("/admin/allsubadmins");
            }, 1000);
          } else {
            toast.error(response.msg);
          }
        });
    },
  });

  //  SET INTIAL VALUE
  useEffect(() => {
    if (UserData.data.data !== undefined) {
      let userStrategyIds =
        UserData.data.data !== undefined &&
        UserData.data.data[0].subadmin_permissions[0];
      formik.setFieldValue(
        "FullName",
        UserData.data.data !== undefined && UserData.data.data[0].FullName
      );
      formik.setFieldValue(
        "email",
        UserData.data.data !== undefined && UserData.data.data[0].Email
      );
      formik.setFieldValue(
        "mobile",
        UserData.data.data !== undefined && UserData.data.data[0].PhoneNo
      );
      formik.setFieldValue(
        "password",
        UserData.data.data !== undefined && UserData.data.data[0].Otp
      );
      formik.setFieldValue(
        "addclient",
        userStrategyIds?.client_add === 1 ? true : false
      );
      formik.setFieldValue(
        "editclient",
        userStrategyIds?.client_edit === 1 ? true : false
      );
      formik.setFieldValue(
        "detailsinfo",
        userStrategyIds?.detailsinfo === 1 ? true : false
      );
      formik.setFieldValue(
        "gotodashboard",
        userStrategyIds?.go_To_Dashboard === 1 ? true : false
      );
      formik.setFieldValue(
        "licence",
        userStrategyIds?.license_permision === 1 ? true : false
      );
      formik.setFieldValue(
        "updateapikeys",
        userStrategyIds?.Update_Api_Key === 1 ? true : false
      );
      formik.setFieldValue(
        "tradehistory",
        userStrategyIds?.trade_history_old === 1 ? true : false
      );
      formik.setFieldValue(
        "Strategy",
        userStrategyIds?.strategy && userStrategyIds?.strategy.length > 0
          ? true
          : false
      );
      formik.setFieldValue(
        "groupservice",
        userStrategyIds?.group_services &&
          userStrategyIds?.group_services?.length !== 0
          ? true
          : false
      );
      formik.setFieldValue(
        "optionchain",
        userStrategyIds?.optionchain === 1 ? true : false
      );
      formik.setFieldValue(
        "makestrategy",
        userStrategyIds?.makestrategy === 1 ? true : false
      );
      formik.setFieldValue(
        "apicreateinfo",
        userStrategyIds?.apicreateinfo === 1 ? true : false
      );
      formik.setFieldValue(
        "Strategy_Permission",
        userStrategyIds?.Strategy_Permission === 1 ? true : false
      );

      formik.setFieldValue(
        "stock_group_service",
        userStrategyIds?.stock_group_service === 1 ? true : false
      );
      formik.setFieldValue(
        "create_strategy",
        userStrategyIds?.create_strategy === 1 ? true : false
      );
      formik.setFieldValue(
        "groupservice_Permission",
        userStrategyIds?.groupservice_Permission === 1 ? true : false
      );
    }
  }, [UserData.data.data]);

  // Define permission fields
  const permissionFields = [
    "addclient",
    "editclient",
    "gotodashboard",
    "licence",
    "detailsinfo",
    "tradehistory",
    "groupservice_Permission",
    "Strategy_Permission",
    "makestrategy",
    "optionchain",
    "apicreateinfo",
    "create_strategy",
    "stock_group_service",
  ];

  // Handle "All Permission" checkbox - when checked/unchecked, enable/disable all permissions
  useEffect(() => {
    if (!isUpdatingAll) {
      setIsUpdatingAll(true);
      if (formik.values.all) {
        permissionFields.forEach((field) => {
          formik.setFieldValue(field, true);
        });
      } else {
        // Only uncheck all if user manually unchecked "all"
        const allCurrentlyChecked = permissionFields.every(
          (field) => formik.values[field]
        );

        if (allCurrentlyChecked) {
          permissionFields.forEach((field) => {
            formik.setFieldValue(field, false);
          });
        }
      }
      setTimeout(() => setIsUpdatingAll(false), 0);
    }
  }, [formik.values.all]);

  // Auto-uncheck "All Permission" when any individual permission is unchecked
  useEffect(() => {
    if (formik.values.all && !isUpdatingAll) {
      const allStillChecked = permissionFields.every(
        (field) => formik.values[field]
      );

      if (!allStillChecked) {
        formik.setFieldValue("all", false);
      }
    }
  }, [
    formik.values.addclient,
    formik.values.editclient,
    formik.values.gotodashboard,
    formik.values.licence,
    formik.values.detailsinfo,
    formik.values.tradehistory,
    formik.values.groupservice_Permission,
    formik.values.Strategy_Permission,
    formik.values.makestrategy,
    formik.values.optionchain,
    formik.values.apicreateinfo,
    formik.values.create_strategy,
    formik.values.stock_group_service,
  ]);

  // Auto-check "All Permission" when all individual permissions are manually checked
  useEffect(() => {
    if (!formik.values.all && !formik.values.updateapikeys && !isUpdatingAll) {
      const allChecked = permissionFields.every(
        (field) => formik.values[field]
      );

      if (allChecked) {
        formik.setFieldValue("all", true);
      }
    }
  }, [
    formik.values.addclient,
    formik.values.editclient,
    formik.values.gotodashboard,
    formik.values.licence,
    formik.values.detailsinfo,
    formik.values.tradehistory,
    formik.values.groupservice_Permission,
    formik.values.Strategy_Permission,
    formik.values.makestrategy,
    formik.values.optionchain,
    formik.values.apicreateinfo,
    formik.values.create_strategy,
    formik.values.stock_group_service,
  ]);

  useEffect(() => {
    if (formik.values.updateapikeys) {
      formik.setFieldValue("all", false);
      permissionFields.forEach((field) => {
        formik.setFieldValue(field, false);
      });
      formik.setFieldValue("groupservice", false);
      formik.setFieldValue("Strategy", false);
    }
  }, [formik.values.updateapikeys]);

  useEffect(() => {
    if (
      formik.values.addclient ||
      formik.values.editclient ||
      formik.values.Strategy ||
      formik.values.groupservice ||
      formik.values.detailsinfo ||
      formik.values.tradehistory ||
      formik.values.gotodashboard ||
      formik.values.optionchain ||
      formik.values.makestrategy ||
      formik.values.Strategy_Permission ||
      formik.values.create_strategy ||
      formik.values.stock_group_service ||
      formik.values.groupservice_Permission ||
      formik.values.apicreateinfo
    ) {
      formik.setFieldValue("updateapikeys", false);
      return;
    }

    if (formik.values.Strategy) {
      formik.setFieldValue("Strategy", true);
      return;
    }

    if (formik.values.groupservice) {
      formik.setFieldValue("groupservice", true);
      return;
    }
    if (formik.values.addclient || formik.values.editclient) {
      formik.setFieldValue("groupservice", true);
      formik.setFieldValue("Strategy", true);
      return;
    } else if (!formik.values.addclient) {
      formik.setFieldValue("groupservice", false);
      formik.setFieldValue("Strategy", false);
      formik.setFieldValue("strateg_servcice", "");
      formik.setFieldValue("grouper_servcice", "");
    } else {
      formik.setFieldValue("groupservice", false);
      formik.setFieldValue("Strategy", false);
      return;
    }
  }, [
    formik.values.editclient,
    formik.values.addclient,
    formik.values.detailsinfo,
    formik.values.tradehistory,
    formik.values.gotodashboard,
    formik.values.Strategy,
    formik.values.groupservice,
    formik.values.optionchain,
    formik.values.makestrategy,
    formik.values.Strategy_Permission,
    formik.values.fullAcess_Permission,
  ]);

  const fields = [
    {
      name: "FullName",
      label: "FullName",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "mobile",
      label: "Mobile",
      type: "number",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "all",
      label: "All Permissions",
      type: "checkbox",
      label_size: 12,
      col_size: 12,
      check_box_true: formik.values.all ? true : false,
    },
    {
      name: "addclient",
      label: "Add Client",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.addclient ? true : false,
    },
    {
      name: "editclient",
      label: "Edit Client",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.editclient ? true : false,
    },
    {
      name: "licence",
      label: "Licence  Permission",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true: formik.values.all || formik.values.licence ? true : false,
    },
    {
      name: "gotodashboard",
      label: "Go To Dashboard",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.gotodashboard ? true : false,
    },
    {
      name: "tradehistory",
      label: "Trade History",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.tradehistory ? true : false,
    },
    {
      name: "detailsinfo",
      label: "Full Info View",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.detailsinfo ? true : false,
    },
    {
      name: "groupservice_Permission",
      label: "Group Service Permission",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.groupservice_Permission
          ? true
          : false,
    },
    {
      name: "Strategy_Permission",
      label: "Strategy Permission",
      type: "checkbox",
      label_size: 12,
      col_size: 5,
      check_box_true:
        formik.values.all || formik.values.Strategy_Permission ? true : false,
    },
    {
      name: "updateapikeys",
      label: "Update Client API Key",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true: formik.values.updateapikeys ? true : false,
    },
    // {
    //   name: "apicreateinfo",
    //   label: "Show API Create Info",
    //   type: "checkbox",
    //   label_size: 12,
    //   col_size: 4,
    //   check_box_true:
    //     formik.values.all || formik.values.apicreateinfo ? true : false,
    // },
    {
      name: "create_strategy",
      label: "Create Startegy",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.create_strategy ? true : false,
    },
    {
      name: "stock_group_service",
      label: "Create Group Service",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      check_box_true:
        formik.values.all || formik.values.stock_group_service ? true : false,
    },
  ];

  useEffect(() => {
      if (formik.values.create_strategy && !formik.values.updateapikeys) {
        // formik.setFieldValue("groupservice", true);
        formik.setFieldValue("Strategy_Permission", true);
      }
       if (formik.values?.stock_group_service && !formik.values.updateapikeys) {
        // formik.setFieldValue("groupservice_Permission", true);
        formik.setFieldValue("groupservice_Permission", true);
      }
  
    }, [formik.values.create_strategy,formik.values.stock_group_service]);

  const data = async () => {
    await dispatch(
      Get_All_Service_for_Client({
        req: {},
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllStrategy({
            loading: false,
            data: response.data,
          });
        }
      });
    await dispatch(GET_ALL_GROUP_SERVICES())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllGroupServices({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  const handleUpdateSubmit = () => {
    const formValues = formik.values;

    const formDetails = `
    <strong>Name:</strong> ${formValues.FullName}<br/>
    <strong>Email:</strong> ${formValues.email}<br/>
    <strong>Phone:</strong> ${formValues.mobile}<br/>
    <strong>Role:</strong> ${formValues.password}<br/>
   
  `;

    Swal.fire({
      title: "Are you sure?",
      html: `
      <div>
        <p className="mb-1">You are about to update the Subadmin's details with the following:</p>
        <div className="text-start" style="line-height: 1.6;">${formDetails}</div>
      </div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then((result) => {
      if (result.isConfirmed) {
        formik.handleSubmit();
      }
    });
  };

  useEffect(() => {
    data();
  }, []);

  useEffect(() => {
    if (UserData.data.data !== undefined && UserData.data.data.length > 0) {
      const userStrategyIds =
        UserData.data.data[0]?.subadmin_permissions[0]?.strategy;
      setSelectedStrategyIds(userStrategyIds);
      const usergropupyIds =
        UserData.data.data[0]?.subadmin_permissions[0]?.group_services;
      setSelectedGroupIds(usergropupyIds);
    }
  }, [UserData.data]);

  useEffect(() => {
    if (
      UserData?.data?.data !== undefined &&
      UserData?.data?.data?.length > 0 &&
      AllStrategy?.data?.length > 0
    ) {
      const user = UserData.data.data[0];

      // ✅ 1️⃣ Get strategy IDs from both sources
      const userStrategies = user?.strategies_data || [];
      const subadminStrategies =
        user?.subadmin_permissions?.[0]?.strategy || [];

      // Extract all strategy IDs
      const userStrategyIds = [
        ...new Set([
          ...userStrategies.map((s) => s._id),
          ...subadminStrategies.map((id) => id), // subadmin may have only IDs
        ]),
      ];

      // ✅ 2️⃣ Merge and check which ones are checked
      const initialCheckedStrategies = AllStrategy.data.map((strategy) => {
        const matched = userStrategies.find((s) => s._id === strategy._id);

        return {
          id: strategy._id,
          name: strategy.strategy_name,
          usernameDisplay: strategy?.usersdata?.UserName || "Admin",
          userName:
            matched?.userName ||
            matched?.added_by_username ||
            strategy.added_by_username ||
            "",
          checked: userStrategyIds.includes(strategy._id),
        };
      });

      // ✅ 3️⃣ Update state
      setCheckedStrategies(initialCheckedStrategies);
    }
  }, [UserData?.data, AllStrategy?.data]);

  const handleStrategyChange = (event) => {
    var strategyId = event.target.value;
    setCheckedStrategies((prevStrategies) => {
      return prevStrategies.map((strategy) => {
        if (strategy.id === strategyId) {
          return { ...strategy, checked: !strategy.checked };
        }
        return strategy;
      });
    });
    setSelectedStrategyIds((prevIds) => {
      if (prevIds?.includes(strategyId)) {
        let abc = prevIds.filter((id) => id !== strategyId);
        return abc;
      } else {
        return [...prevIds, strategyId];
      }
    });
  };

  //  For Select Group Change Change
  useEffect(() => {
    if (UserData.data.data !== undefined && UserData?.data?.data.length > 0) {
      const userStrategyIds =
        UserData?.data?.data !== undefined &&
        UserData.data.data[0]?.subadmin_permissions[0]?.group_services;
      const initialCheckedStrategies =
        AllGroupServices.data &&
        AllGroupServices.data.map((strategy) => {
          return {
            id: strategy._id,
            name: strategy.name,
            checked: userStrategyIds?.includes(strategy._id),
          };
        });
      setCheckedGroupServices(initialCheckedStrategies);
    }
  }, [UserData.data, AllGroupServices.data]);

  const handleStrategyChange1 = (event) => {
    const strategyId = event.target.value;
    setCheckedGroupServices((prevStrategies) => {
      return prevStrategies.map((strategy) => {
        if (strategy.id === strategyId) {
          return { ...strategy, checked: !strategy.checked };
        }
        return strategy;
      });
    });

    setSelectedGroupIds((prevIds) => {
      if (prevIds?.includes(strategyId)) {
        return prevIds.filter((id) => id !== strategyId);
      } else {
        return [...prevIds, strategyId];
      }
    });
  };

  return (
    <Content
      Page_title="Edit Sub-Admin"
      button_title="Back"
      route="/admin/allsubadmins"
    >
      <Formikform
        fieldtype={fields.filter((field) => !field.showWhen)}
        hidebtn={true}
        formik={formik}
        onClick={handleUpdateSubmit}
        additional_field={
          <>
            {/* Your extra UI (checkboxes) */}
            {formik.values.groupservice_Permission && (
              <>
                <h6 className="fw-bold mt-4 text-decoration ">
                  All Group Service
                </h6>
                <div className="d-flex flex-wrap gap-3">
                  {checkedGroupServices.map((strategy) => (
                    <div
                      key={strategy.id}
                      className="form-check custom-checkbox me-4 mb-3 mt-4"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name={strategy.id}
                        value={strategy.id}
                        onChange={handleStrategyChange1}
                        checked={strategy.checked}
                        id={`group-${strategy.id}`}
                      />
                      <label
                        className=" form-check-label  fw-normal"
                        htmlFor={`group-${strategy.id}`}
                      >
                        {strategy.name}
                      </label>
                    </div>
                  ))}
                </div>

                {formik.errors.grouper_servcice && (
                  <div style={{ color: "red" }}>
                    {formik.errors.grouper_servcice}
                  </div>
                )}
              </>
            )}

            {formik.values.Strategy_Permission && (
              <>
                <h6 className="fw-bold mt-3 text-decoration">All Strategy</h6>

                <div className="d-flex flex-wrap gap-3 mt-2">
                  {checkedStrategies.map((strategy) => (
                    <div
                      key={strategy.id}
                      className="form-check custom-checkbox me-4 mb-3 mt-4 fw-normal"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name={strategy.id}
                        value={strategy.id}
                        onChange={handleStrategyChange}
                        checked={strategy.checked}
                        id={`strategy-${strategy.id}`}
                        disabled={strategy.userName}
                      />
                      <label
                        className=" form-check-label  fw-normal"
                        htmlFor={`strategy-${strategy.id}`}
                      >
                        <span>
                          {strategy.name}
                          {strategy.usernameDisplay
                            ? ` (${strategy.usernameDisplay})`
                            : ""}
                        </span>
                      </label>
                    </div>
                  ))}
                </div>

                {formik.errors.strateg_servcice && (
                  <div style={{ color: "red" }}>
                    {formik.errors.strateg_servcice}
                  </div>
                )}
              </>
            )}

            <div className="text-start mt-4 ">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdateSubmit}
              >
                Update
              </button>
            </div>
          </>
        }
      />
      <ToastButton />
    </Content>
  );
};

export default AllSubadmin;